/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const bricklane: CommunityData = {
  code: "bricklane",
  inviteCode: "bljf",
  name: "Brick Lane Jazz Festival",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/bljf`,
  socials: {
    instagramLink: "https://www.instagram.com/bricklanejazzfestival/?hl=en",
  },
  styles: {
    global: {
      mobileOnly: true,
      counterColor: "#D6FF99",
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/BLJF/logo-regular.png",
        styles: "w-[150px] mb-[-20px]",
      },
      logo: {
        src: "https://media.werz.at/community/icon/cm860b33z0002ye9kc5lhnfpa.jpg?uploadTime=1759995254754&type=image&v=1762238616236",
        styles: "w-[236px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "",
      bgColor: "#222222",
      asideBg: "#D6FF99",
      asideStyles: "border-r-[1px] border-[#00000040]",
      contentBg: "",
      bgDesktop:
        "https://media.werz.at/community-assets/BLJF/web-landing.mp4?type=video&v=20260409",
      bgMobile: "https://media.werz.at/community-assets/BLJF/web-landing.mp4?type=video&v=20260409",
      mainFont: "font-['Arial']",
      nonMemberBg:
        "https://media.werz.at/community-assets/BLJF/web-landing.mp4?type=video&v=20260409",
      primaryButton: "bg-[#D6FF99] px-[24px] py-[16px] !text-[#222222] font-['Arial'] !text-[20px]",
      scrollArrow: {
        background: "#D6FF99",
        color: "#222222",
      },
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-[#00000040]",
      iconsColor: "#000000",
      separator: "#D6FF994D",
      item: "text-[#000] font-['Arial'] text-[18px] text-left gap-x-[10px] -ml-2 text-opacity-50 text-center !pl-0 !py-2",
      itemSelected: "text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#222222] !pb-8 overflow-hidden",
      titles: "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%]",
      emptyOrLoadingState: "!mx-4 sm:!mx-8 text-[#D6FF99] font-['Arial'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#D6FF994D]",
        sectionTitle:
          "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container: "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#D6FF99] font-['Arial'] text-[20px] text-left leading-[100%]",
          subtitle: "text-[#D6FF99] font-['Arial'] text-[14px] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#D6FF994D]",
        sectionTitle:
          "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 sm:!h-[128px] relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title: "text-[#D6FF99] font-['Arial'] sm:text-[20px] text-left text-[20px]",
          subtitle: "text-[#D6FF99] font-['Arial'] text-[14px] text-left",
          location: "text-[#D6FF99] font-['Arial'] text-[14px] text-left line-clamp-2",
          date: "text-[#D6FF99] font-['Arial'] text-[14px] text-left",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%]",
        text: "text-[#D6FF99] font-['Arial'] text-[14px] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%] !mb-4 sm:!mb-4",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#222222] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%]",
        subtitle: "text-[#D6FF99] font-['Arial'] text-[14px] text-left mb-4 mt-2",
        button:
          "bg-[#D6FF99] !px-[24px] !py-[16px] !w-fit mb-4 sm:mb-0 text-[#222222] font-['Arial'] text-[20px] text-left",
        questions: "text-[14px] text-left text-[#D6FF99]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-t border-[#D6FF994D]",
        header: "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%]",
        text: "text-[#D6FF99] font-['Arial'] text-[14px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-t border-[#D6FF994D]",
        header: "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%]",
        text: "text-[#D6FF99] font-['Arial'] text-[14px] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#D6FF99",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-t border-[#D6FF994D]",
        header: "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%]",
        text: "text-[#D6FF99] font-['Arial'] text-[14px] text-left",
      },
      tickets: {
        header:
          "text-[#D6FF99] font-['Arial'] text-[28px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#222222] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button: "!bg-[#D6FF99] !px-3 !py-2 text-[#222222] font-['Arial'] !text-[20px] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto py-4 !border-b !border-[#D6FF994D]",
          media: "!hidden",
          name: "text-[#D6FF99] font-['Arial'] text-[20px] text-left",
          description: "text-[#D6FF99] font-['Arial'] text-[14px] text-left leading-[120%] !mt-1",
          price: "text-[#D6FF99] font-['Arial'] text-[20px] text-left leading-[100%] !mt-1",
          quantity: "text-[#222222] font-['Arial'] text-[20px] text-left mt-1",
          status: "text-[#D6FF99] font-['Arial'] text-[20px] text-left leading-[100%]",
          counterContainer: "bg-[#D6FF99] border-2 border-[#D6FF99] px-4 py-3 gap-x-4 !w-fit !h-10",
          button: "!bg-[#D6FF99] !px-3 !py-2 text-[#222222] font-['Arial'] !text-[20px] !w-fit",
          plusMinusColor: "#222222",
        },
      },
    },
  },
}

export default bricklane
